import TrackingHistoryAPI from '@/app/apis/main/telstra/tracking-history/tracking-history.js';

export default {
  /**
   * @param {*} trackingDetails contains tracking details
   * @returns {object} tracking history details
   */
  async getTrackingDetails(trackingDetails) {
    return TrackingHistoryAPI.getTrackingDetails(trackingDetails);
  }
};
